export default "__VITE_ASSET__a34d1b42__"